import { PersonType } from '@dealstack/shared/lib/generated';
import { useTransactionPartyPivRelation } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Transactions/hooks/useTransactionPartyPivRelation';

interface UseTransactionPivRelationsParams {
	buyerId?: string | null;
	sellerId?: string | null;
	personsSelectOptions: {
		value: string;
		label: string;
		type: PersonType;
	}[];
	setValue: (name: string, value: string | null) => void;
	getValues: (name: string) => string | null;
	boughtForField: string;
	soldForField: string;
}

/**
 * Buyer + seller PIV relations for a transaction form — the two holding parties every transaction can
 * have. A nominee paired issue has a THIRD (the nominee taking legal title); that one calls
 * useTransactionPartyPivRelation directly, because its bought-for must be scoped to the nominee rather
 * than to the buyer.
 */
export const useTransactionPivRelations = ({
	buyerId,
	sellerId,
	personsSelectOptions,
	setValue,
	getValues,
	boughtForField,
	soldForField,
}: UseTransactionPivRelationsParams) => {
	const buyer = useTransactionPartyPivRelation({
		partyId: buyerId,
		personsSelectOptions,
		setValue,
		getValues,
		holdsForField: boughtForField,
	});

	const seller = useTransactionPartyPivRelation({
		partyId: sellerId,
		personsSelectOptions,
		setValue,
		getValues,
		holdsForField: soldForField,
	});

	return {
		hideBoughtFor: buyer.hideHoldsFor,
		hideSoldFor: seller.hideHoldsFor,
		boughtForOptions: buyer.holdsForOptions,
		soldForOptions: seller.holdsForOptions,
	};
};
